import React from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { Doughnut } from "react-chartjs-2";
import { bucketTopN } from "./_shared/bucketTopN";
import CustomLegend from "./_shared/CustomLegend";
import ChartState from "./_shared/ChartState";
import { donutOptions } from "./_shared/chartTheme";

const DiamondReportsClarityComp = ({ data, loading }) => {
  const { t } = useTranslation();

  const { chartData, colors } = bucketTopN(data || [], {
    labelKey: "Clarity",
    valueKey: "CNT",
    chartLabel: "Clarity",
    othersLabel: t("Others"),
  });
  const rows = chartData.slice(1);

  const chartJsData = {
    labels: rows.map((row) => row[0]),
    datasets: [
      {
        data: rows.map((row) => row[1]),
        backgroundColor: colors,
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <label>
          <b> {t("Diamond Clarity Searches")} </b>
        </label>
        <div
          className="chart__section"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Spin spinning={loading} size="large">
            {rows.length > 0 ? (
              <>
                <CustomLegend chartData={chartData} colorData={colors} />
                <div className="edr-chartwrap edr-tall">
                  <Doughnut data={chartJsData} options={donutOptions} />
                </div>
              </>
            ) : (
              <ChartState loading={loading} />
            )}
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsClarityComp;
